<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<div id="background"></div>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-aiss-sso-login></app-aiss-sso-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-aiss-sso-register></app-aiss-sso-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-aiss-sso-forgot-password></app-aiss-sso-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-aiss-sso-change-password-sent></app-aiss-sso-change-password-sent>
  </div>

  <app-aiss-sso-register-resend
    *ngIf="page === 'register-resend'"
  ></app-aiss-sso-register-resend>
</ng-container>
